import { render } from "./SubNavProfile.vue?vue&type=template&id=4894bd4b"
import script from "./SubNavProfile.vue?vue&type=script&lang=js"
export * from "./SubNavProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__